import { useTranslation } from '@mint-lib/i18n';
import { useFlags } from '@mint-lib/routing-context';
import { Divider, Switch, SwitchLabel } from '@mint-lib/tw-components';

import BarContainer from './components/BarContainer.jsx';
import ManageFlightsBtn from './components/ManageFlightsBtn.jsx';
import RowActionsAndExport from './components/RowActionsAndExport.jsx';
import SendOrderBtn from './components/SendOrderBtn.jsx';
import { ImportPlanModal } from './ImportPlanModal/ImportPlanModal.jsx';

const ActivityActionBar = () => {
  const { t } = useTranslation('@myn/planning_v2');
  const ff = useFlags('@mint/arm', ['disableActivityLevel']);

  return (
    <BarContainer>
      <div className="flex gap-2">
        <ManageFlightsBtn />
        <SendOrderBtn />
      </div>
      <div className="flex items-center gap-2">
        {!ff.disableActivityLevel.enabled && <ImportPlanModal />}

        <SwitchLabel disabled>
          <Switch size="small" disabled />

          {t('Carbon offset')}
        </SwitchLabel>

        <Divider orientation="vertical" />
        <RowActionsAndExport />
      </div>
    </BarContainer>
  );
};

export default ActivityActionBar;
